var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHello(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.196 16.658",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_494",
    "data-name": "Groupe 494",
    transform: "translate(-570.909 -85.471)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_586",
    "data-name": "Trac\\xE9 586",
    d: "M582.122,15.632c.965-1.132.741-3.183.434-4.885-.549-3.045,1.32-3.446.654-4.2-.468-.533-1.57-.087-2.041.516-.422.542-.387,1.5-.542,1.979-.287.9-1.036.144-1.848-.787-.43-.493-2.815-3.435-3.351-4.051a1.075,1.075,0,0,0-1.451-.1,1.124,1.124,0,0,0-.166,1.3c.321.51,2.891,3.451,3.093,3.688s.4.36-.01,0-3.228-3.878-3.6-4.3a1.151,1.151,0,0,0-1.584-.067,1.222,1.222,0,0,0-.1,1.734c.251.343,3.639,4.137,3.917,4.427s.3.277,0,.006-3-3.443-3.339-3.756a1.269,1.269,0,0,0-1.445.121,1.238,1.238,0,0,0-.115,1.517c.22.287,3.654,3.891,3.874,4.094s.329.3-.009.007-1.649-1.732-1.987-2.087a1.219,1.219,0,0,0-1.58-.046,1.318,1.318,0,0,0-.078,1.467c.233.245,4.009,3.721,4.466,4.145a5.5,5.5,0,0,0,3.053,1.531C579.6,17.886,580.842,17.133,582.122,15.632Z",
    transform: "translate(3.278 83.752)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_587",
    "data-name": "Trac\\xE9 587",
    d: "M579.9,1.991a5.332,5.332,0,0,1,2.643,3.149",
    transform: "translate(1.326 84.138)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_588",
    "data-name": "Trac\\xE9 588",
    d: "M567.71,16.338a5.332,5.332,0,0,0,2.954,2.859",
    transform: "translate(3.837 81.182)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_589",
    "data-name": "Trac\\xE9 589",
    d: "M569.02,15.674a4.112,4.112,0,0,0,2.278,2.2",
    transform: "translate(3.567 81.319)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_590",
    "data-name": "Trac\\xE9 590",
    d: "M579.244,3.4a4.111,4.111,0,0,1,2.038,2.428",
    transform: "translate(1.461 83.848)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHello);
export default __webpack_public_path__ + "static/media/hello.3efb620872b930e1967205a7abd2394a.svg";
export { ForwardRef as ReactComponent };